import { memo } from "react";
import type { BadgeProps, BadgeVariant } from "../types";
import { colors, radius, spacing, typography } from "../tokens";

const variantMap: Record<BadgeVariant, { bg: string; color: string }> = {
  success: { bg: "rgba(34,197,94,0.15)", color: colors.success },
  error: { bg: "rgba(239,68,68,0.15)", color: colors.error },
  warning: { bg: "rgba(245,158,11,0.15)", color: colors.warning },
  info: { bg: "rgba(59,130,246,0.15)", color: colors.info },
  neutral: { bg: "rgba(255,255,255,0.08)", color: colors.textMuted },
};

export const Badge = memo(function Badge({ label, variant = "neutral" }: BadgeProps) {
  const { bg, color } = variantMap[variant];

  return (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        padding: `${spacing.xs} ${spacing.sm}`,
        borderRadius: radius.full,
        background: bg,
        color,
        fontFamily: typography.fontFamily,
        fontSize: typography.size.xs,
        fontWeight: typography.weight.semibold,
        letterSpacing: "0.04em",
        textTransform: "uppercase",
      }}
    >
      {label}
    </span>
  );
});
